import { render } from "./makeInvoiceRecordsDetails.vue?vue&type=template&id=90be503e"
import script from "./makeInvoiceRecordsDetails.vue?vue&type=script&lang=js"
export * from "./makeInvoiceRecordsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])